import React, { useEffect } from "react";
import "aos/dist/aos.css";
import AOS from "aos";
import "./email.css";
import { ASSETS_BASE_URL } from "constants";

const Failed = () => {
  useEffect(() => {
    AOS.init();
  }, []);

  return (
    <main className="main section container full-page">
      <div className="d-flex flex-column center-content text-align-center justify-content-center align-items-center">
        <img
          src={`${ASSETS_BASE_URL}assets/images/rize/email/failed.svg`}
          alt="Failed"
          className="success-img"
        />

        <p className="email-title">Oops! Email verification failed.</p>

        <h5 className="email-subtitle">
          We’re facing some technical issues and couldn’t verify your email. Please open the MY alrajhi app and try again shortly, or contact us for help:
          <br />
          Customer Care:{" "}
          <a
            href="tel:+60323326000"
            style={{ color: "#221afb", textDecoration: "none" }}
          >
            +603 2332 6000
          </a>{" "}
          <br />
          Email:{" "}
          <a
            href="mailto:customersupport@alrajhibank.com.my"
            style={{ color: "#221afb", textDecoration: "none" }}
          >
            customersupport@alrajhibank.com.my
          </a>
          <br />
          <br />
          Thanks for your patience – we’ll get this sorted soon!
        </h5>
      </div>
    </main>
  );
};

export default Failed;
